<span
  class="nav-focus-bridge"
  tabindex="0"
  role="link"
  aria-label="Main navigation"
  (focus)="onFocus()"
  (keydown.enter)="onActivate()"
></span>
